import React from "react";
import Hls from "hls.js";
import './video.css'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faXmark } from '@fortawesome/free-solid-svg-icons'
import { useContext, useEffect, useRef } from 'react';
import NhlGamesContext from './context/Context';

function prefersMobileFullscreen() {
  if (typeof navigator === "undefined") {
    return false;
  }

  return /Android|iPhone|iPod/i.test(navigator.userAgent);
}

// <HLSPlayer trigger={play} setPlaying={setPlay} video={videourl} toggle={toggle}/>
function HLSPlayer() {
  const {toggle, play, setPlay, videourl} = useContext(NhlGamesContext);
  const videoRef = useRef(null);
  const useNativeMobileFullscreen = prefersMobileFullscreen();

  useEffect(() => {
    const video = videoRef.current;
    if (!play || !video || !videourl) {
      return undefined;
    }

    let hls = null;
    let requestedFullscreen = false;

    const maybeEnterFullscreen = () => {
      if (!useNativeMobileFullscreen || requestedFullscreen) {
        return;
      }

      const nativeFullscreen = video.webkitEnterFullscreen?.bind(video);
      const standardFullscreen = video.requestFullscreen?.bind(video);
      const fullscreenRequest = nativeFullscreen ?? standardFullscreen;

      if (!fullscreenRequest) {
        return;
      }

      requestedFullscreen = true;

      try {
        const result = fullscreenRequest();
        if (result?.catch) {
          result.catch(() => {
            requestedFullscreen = false;
          });
        }
      } catch {
        requestedFullscreen = false;
      }
    };

    if (Hls.isSupported()) {
      hls = new Hls({
        enableWebVTT: false,
        testBandwidth: false,
      });
      hls.on(Hls.Events.MANIFEST_PARSED, (_, data) => {
        if (!data.levels?.length) {
          return;
        }

        const highestLevel = data.levels.reduce((bestIndex, level, index, levels) => {
          const bestBitrate = levels[bestIndex]?.bitrate ?? 0;
          const currentBitrate = level?.bitrate ?? 0;
          return currentBitrate >= bestBitrate ? index : bestIndex;
        }, 0);

        // These replay clips are short, so favor immediate top quality over ABR ramp-up.
        hls.startLevel = highestLevel;
        hls.loadLevel = highestLevel;
      });
      hls.attachMedia(video);
      hls.loadSource(videourl);
    } else if (video.canPlayType("application/vnd.apple.mpegurl")) {
      video.src = videourl;
      video.load();
    } else {
      video.src = videourl;
      video.load();
    }

    video.addEventListener("playing", maybeEnterFullscreen);
    const autoplay = video.play();
    if (autoplay?.catch) {
      autoplay.catch(() => {});
    }

    return () => {
      video.removeEventListener("playing", maybeEnterFullscreen);
      if (hls) {
        hls.destroy();
      }
      video.pause();
      video.removeAttribute("src");
      video.load();
    };
  }, [play, videourl, useNativeMobileFullscreen]);

  return play ? (
    <div className='popup' >
      <div className="video-overlay" onClick={() => setPlay(!play)}></div>
    <div className="video-player">

    <FontAwesomeIcon onClick={() => setPlay(!play)} className='close-btn' icon={faXmark} />

    <video
      ref={videoRef}
      className={`${toggle ? "" : "novid"}`}
      autoPlay={true}
      controls={true}
      playsInline={!useNativeMobileFullscreen}
      preload="auto"
      width="100%"
      height="auto"
    />
    </div></div>
      ) : null;

}

export default HLSPlayer
